<div class="row">
  <div class="col-12">
    <form method="post" id="qtCaracteresSinopseForm" autocomplete="off" [formGroup]="qtCaracteresSinopseForm" (ngSubmit)="submit()">
      <div class="col-12">
        <label for="qtd">Quantidade de caracteres</label>
        <input nz-input id="qtd" type="number" formControlName="qtd" placeholder="Valores entre 50-1000"  min="50" max="1000"/>
      </div>
      <div>
        <div class="col-12 d-flex mt-4">
          <button nz-button nzType="primary" type="button" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 me-3" nzDanger
            (click)="voltar()">
            Voltar
            <span class="fs-4 ms-2 carbon--close-outline"></span>
          </button>
          <button nz-button nzType="primary" type="submit" form="qtCaracteresSinopseForm" nzSize="large"
            class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6">
            {{regerar? 'Regerar' : 'Gerar' }} Sinopse
            <span class="fs-4 ms-2 system-uicons--close"></span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>